<template>
    <div class="content-wapper">

        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">小微驿站</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/xwqyczfw/rcdj' }">人才对接</el-breadcrumb-item>
                    <el-breadcrumb-item>企业招聘详情</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>

        <el-card>
            <el-row>
                <span align="left">
                    <el-row>
                        <div style="font-size: 30px;font-weight: bold;margin-bottom: 20px;display: inline;">
                            {{qyzpxx.postName}}
                        </div>
                        <div class="salaryStyle">
                            {{qyzpxx.salary}}元/月
                        </div>
                        <div class="lookedStyle">
                            {{qyzpxx.looked}}人已看过
                        </div>
                    </el-row>
                    <el-row style="margin-top: 10px">
                        <el-col :span="8" align="left">
                            企业名称：{{qyzpxx.entname}}
                        </el-col>
                        <el-col :span="8" align="center">
                            详细地址：{{qyzpxx.dom}}
                        </el-col>
                        <el-col :span="8" align="right" style="padding-right: 20px">
                            所属区域：{{qyzpxx.deptCode}}
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24" style="margin-top: 18px;" align="left">公司简介：
                            <div style="line-height: 25px;text-indent: 28px;text-align: left" align="left">
                          {{qyzpxx.entIntroduction}}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <div style="margin-top: 10px;color: #00afff">
                             招{{qyzpxx.demandNumber}}人&nbsp;|&nbsp;{{recruitmentFormFormat(qyzpxx.recruitmentForm)}}&nbsp;|&nbsp;{{qyzpxx.demandSpecialty}}
                        </div>
                    </el-row><br>
                    <el-row>
                        <el-col :span="3">
                        <el-tag v-if="!isLoginState">登录后查看</el-tag>
                        <span v-if="isLoginState">联系人：{{qyzpxx.lxr}}</span>
                        </el-col>
                        <el-col :span="8" align="left">
                        <el-tag v-if="!isLoginState">登录后查看</el-tag>
                        <span v-if="isLoginState">联系电话：{{qyzpxx.tel}}</span>
                        </el-col>

                    </el-row>
                </span>
            </el-row>

            <el-divider></el-divider>

            <el-row>
                <span align="left">
                    <div style="font-size: 30px;font-weight: bold">
                        |&nbsp;&nbsp;岗位描述
                    </div>
                    <div class="contentStyle">
                        {{qyzpxx.jobDescription}}
                    </div>
                    <!--
                    <div class="smallType">
                        岗位职责:
                    </div>
                    <div class="contentStyle">
                        {{gwzzxxlist[0].content}}
                    </div>
                     <div class="contentStyle">
                        {{gwzzxxlist[1].content}}
                    </div>
                             <div class="contentStyle">
                       {{gwzzxxlist[2].content}}
                    </div>
                           <div class="contentStyle">
                       {{gwzzxxlist[3].content}}
                    </div>
                    -->
                </span>
                <!--
                <span align="left">
                    <div class="smallType">
                        任职要求:
                    </div>
                    <div class="contentStyle">
                        {{rzyqxxlist[0].content}}
                    </div>
                    <div class="contentStyle">
                        {{rzyqxxlist[1].content}}
                    </div>
                    <div class="contentStyle">
                        {{rzyqxxlist[2].content}}
                    </div>
                    <div class="contentStyle">
                         {{rzyqxxlist[3].content}}
                    </div>
                </span>
                <span align="left">
                    <div class="smallType">
                        加分项:
                    </div>
                    <div class="contentStyle">
                        有以下行业经验：移动互联网、互联网、计算机软件。
                    </div>
                </span>
                -->
            </el-row>
        </el-card>
    </div>
</template>

<script>
    import { getQyzpxx } from "@/api/xwqy/qyzpxx";

    export default {
        name: "qyzpxxDetail",
        data() {
            return {
                // 遮罩层
                loading: true,
                recid: undefined,
                /*
                qyzpxx: {
                    recid: '1',
                    gwName: '数控操作',
                    salary: '15000-30000',
                    looked: '200',
                    dom: '威海中关村科技园区',
                    region: '环翠区',
                    synopsis: '大田工业科技（威海）有限公司（Beijing Newlink Technology Co.,Ltd.）2011年成立于威海科技园区，注册资本金1.02亿元，现有员工500+人，是高新技术企业、双软认证企业、自主可靠软件产品企业。2021年1月，新纽科技有限公司于香港联合交易所有限公司主板挂牌交易，股票代码：9600.HK。公司总部位于北京，在上海、西安等地设有分支机构，隶属中国金融机构IT解决方案提供商中排名前100。新纽科技是以大数据、人工智能相关领域解决方案及软件产品在金融行业、医疗行业实践与落地应用为主的软件服务商。公司专注为国金融行业、医疗行业客户提供全面的IT系统产品、技术解决方案与相关系统建设服务。且与多所国内知名高校建立了长期战略合作关系，以国家级实验室为依托，共同在大数据、人工智能领域开展技术创新与产品研发，是大学前沿科技研究成果转化成实际应用的重要合作伙伴。新纽科技取得了ISO9001质量管理体系认证、ISO20000服务管理体系认证、ISO27001信息安全管理体系认证、CMMI软件能力成熟度5级认证、软件企业认证、高新技术企业、北京市信用AAA级企业等资质证书，并拥有独立的软件研发中心。公司秉承“诚信为本、开拓创新、服务至上、共同发展”的经营理念，凭借自身精湛的技术实力、完善的管理体系及优异的服务能力，赢得了广大用户的信任，并与众多客户建立了长期的战略性的合作关系，树立了良好的企业形象。新纽科技致力于通过凝聚和吸纳优秀人才，不断提升核心技术水平、开发实施能力及综合服务能力，构建紧密的全国营销体系、售后服务体系。新纽科技期待与各界朋友携手并进，把公司建设成为让员工自豪、令客户满意、获行业尊敬，具有品牌影响力的IT服务企业。',
                    zpxs: '实习',
                    entname: '大田工业科技（威海）有限公司',
                    xqrs: '4',
                    lxr: '张三',
                    tel: '86237918',
                    major: '电气自动化技术数控技术',
                },/!**！！！！！！！需要注意的是从岗位描述开始往下什么岗位职责、任职要求、加分项什么的 在后台编辑的是 富文本框，用户可以自己想写什么些什么，是没有标准格式的*!/
                */
                qyzpxx:{},
                gwzzxxlist: [
                    {content: '1、负责研发团队的搭建、人才培养和团队日常管理工作；'},
                    {content: '2、负责研发中心核心业务系统的研发管理以及项目推进工作；'},
                    {content: '3、深入理解公司业务，参与系统架构设计、优化、提升扩展性和开发效率；'},
                    {content: '4、持续改善已有服务，优化系统薄弱点，提升系统整体质量；'},
                ],
                rzyqxxlist: [
                    {content: '1、本科及本科以上学历，5年以上java开发经验，2年及以上的开发团队管理经验，有主导设计和开发复杂系统的经验；'},
                    {content: '2、扎实的java编程基础，熟悉JVM原理、SpringBoot、Dubbo、Redis、RabbitMQ、ES等常用框架和中间件；'},
                    {content: '3、了解软件性能分析、调优等相关方法、有一定的技术前瞻性；'},
                    {content: '4、熟悉整个软件开发和项目管理流程，具有高效沟通和把控项目进度管理能力。'},
                ],
                recruitmentForms:[],
                isLoginState:false,
            }
        },
        created() {
            this.getDicts("qyzpxx_recruitment_forms").then(response => {
                this.recruitmentForms = response.data;
            });
            this.recid = this.$route.params && this.$route.params.recid;
            this.getQyzpxx();
            this.checkLogin();
        },
        methods: {
            checkLogin(){
				//----【】需要修改为recid
				let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
				if (ssessionLoginUser != null && ssessionLoginUser.islogin) {
					this.isLoginState = true;
				} else {
					this.isLoginState = false;
				}
            },
            recruitmentFormFormat(value) {
                return this.selectDictLabel(this.recruitmentForms, value);
            },
            toPage(url) {
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            getQyzpxx() {
                const recid = this.recid;
                getQyzpxx(recid).then(response => {
                    this.qyzpxx = response.data;
                    this.qyzpxx.looked = 200;
                });
            },
            refresh() {
                // this.getMarket();
            },

        }
    }
</script>

<style scoped>
    .content-wapper{
        margin-top: 5px;
        padding: 10px;
    }
    .navigation{
        padding:20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }

    .left-img img {
        /*max-height: 260px;*/
        height: 282px;
        width: 180px;
    }

    .card-header-left img {
        height: 30px;
    }

    .zscqzx-img img {
        height: 60px;
    }

    .zscqzx-img-1 img {
        height: 13rem;
    }

    .salaryStyle {
        margin: 26px 20px 0 0;
        font-size: 24px;
        color: orange;
        float: right;
    }

    .lookedStyle {
        margin-top: 15px;
        width: 100px;
        padding: 2px 5px 2px 5px;
        border:1px solid lightgrey;
        background-color: whitesmoke;
        text-align: center;
        font-size: 10px;
    }

    .contentStyle {
        margin-top: 13px;
        line-height: 15px;
        text-indent: 18px;
        margin-bottom: 5px
    }
    .smallType {
        font-size: 14px;
        font-weight: bold;
        padding: 10px 0 10px 0
    }

</style>